var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-center"},[_c('h1',{staticClass:"red--text"},[_vm._v("Access Denied")]),_c('p',[_vm._v("The application is currently inactive.")])])}
var staticRenderFns = []

export { render, staticRenderFns }